import React from 'react';
import { Table, ColumnDefinition, RowDefinition } from '@indigo-ag/component-module';

export interface CardTableInfo {
  title: string | JSX.Element;
  value: string | React.ReactNode | undefined;
}

export interface CardTableProps {
  info: CardTableInfo[];
}

type CardTableInfoWithId = CardTableInfo & { id: string };

type ColumnId = 'title' | 'value';
const columnDefinition: ColumnDefinition<CardTableInfoWithId, ColumnId>[] = [
  {
    id: 'title',
    header: '',
    cell: ({ row, SimpleCell }) => {
      if (typeof row.title === 'string') {
        return <SimpleCell label={row.title} />;
      } else {
        return row.title;
      }
    }
  },
  {
    id: 'value',
    header: '',
    cell: ({ row, SimpleCell }) => {
      if (typeof row.value === 'string') {
        return <SimpleCell label={`${row.value || ''}`} />;
      } else {
        return row.value;
      }
    }
  }
];
const rowDefinition: RowDefinition<CardTableInfoWithId, ColumnId> = {
  rowId: ({ row }) => `${row.id}`
};

export const CardTable: React.FunctionComponent<CardTableProps> = ({ info }) => {
  const infoWithId: CardTableInfoWithId[] = info.map((item, idx) => {
    return {
      id: typeof item.title === 'string' ? item.title : `cardTableItem-${idx}`,
      ...item
    };
  });

  return (
    <Table label="Card table" columnDefinition={columnDefinition} rowDefinition={rowDefinition} data={infoWithId} />
  );
};
